// extracted by mini-css-extract-plugin
export default {"Container":"FooterInfo_Container__Udky4","Badges":"FooterInfo_Badges__BzIw0"};